import type {
  BdExportAsFileDataRow,
  BdExportAsFileDataSheet,
} from '@bindoc-projects/util-domain-lib';
import {
  BdExportAsFileData
} from '@bindoc-projects/util-domain-lib';

export class KostDataImportLogExport extends BdExportAsFileData {
  public rows: string[];

  constructor() {
    super();
  }

  override getExport(): Promise<BdExportAsFileDataSheet> {
    return Promise.resolve({
      fields: ['Log'],
      data: this.rows.map((row) => {
        return [
          {
            value: row,
            type: 'string',
          },
        ];
      }) as BdExportAsFileDataRow[],
    });
  }
}
